import React from "react";
import { Helmet } from "react-helmet";
import PageTitle from "../components/PageTitle";
import { Settings } from "../configuration/settings";
import { Link } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs";

function About() {
    return (
        <>
            <Helmet>
                <title>Про нас - {Settings.shopName} | Оригінальні чоловічі джинси Levi’s в Україні</title>
                <meta name="description" content={`${Settings.shopName} - інтернет-магазин оригінальних чоловічих джинсів Levi’s в Україні. Працюємо з 2020 року, гарантуємо якість та доставку по всій країні.`}/>
                <link rel="canonical" href={`${Settings.siteUrl}/about/`} />
            </Helmet>
            <Breadcrumbs items={[ { text: "Про нас"} ]} />
            <PageTitle title="Про нас" />
            <div className="text-start">
                <p>
                    <strong>{Settings.shopName}</strong> - невеликий український інтернет-магазин, 
                    який спеціалізується на продажі <strong>оригінальних чоловічих джинсів Levi’s</strong>. 
                    Наш сайт працює з <strong> 2020 року</strong>, і з самого початку ми зосередилися на одному напрямку -
                    якісних та стильних джинсах для чоловіків від легендарного бренду Levi’s.
                </p>

                <h2 className="fs-5">Чому саме Levi’s?</h2>
                <p>
                    Levi’s - це культовий бренд чоловічих джинсів, який поєднує комфорт, надійність і стиль,
                    перевірений часом. Ми обрали Levi’s, тому що цінуємо:
                </p>
                <ul>
                    <li>якісні матеріали та міцне пошиття</li>
                    <li>зручну чоловічу посадку</li>
                    <li>класичний та сучасний дизайн</li>
                    <li>довговічність у щоденному носінні</li>
                </ul>
                <p>
                    У нашому каталозі представлені популярні
                    <strong> чоловічі моделі джинсів Levi’s</strong> - від класичних прямих фасонів
                    до сучасних варіантів для повсякденного стилю.
                </p>

                <h2 className="fs-5">Оригінальність і довіра</h2>
                <p>
                    Ми співпрацюємо <strong>виключно з перевіреними постачальниками</strong>, тому
                    гарантуємо <strong>100% оригінальні чоловічі джинси Levi’s</strong>, вироблені для ринку Сша.
                    Кожна пара проходить перевірку перед відправленням, щоб ви отримали саме той
                    продукт, на який розраховуєте.
                </p>

                <h2 className="fs-5">Онлайн-магазин без офлайн-точки</h2>
                <p>
                    Ми не маємо фізичного магазину - усі продажі здійснюються онлайн. Це дозволяє нам:
                </p>
                <ul>
                    <li>пропонувати конкурентні ціни на чоловічі джинси Levi’s</li>
                    <li>швидко обробляти замовлення</li>
                    <li>надавати персональні консультації</li>
                    <li>здійснювати доставку по всій Україні</li>
                </ul>
                <p>
                    Замовити <strong>чоловічі джинси Levi’s з доставкою по Україні</strong> можна
                    з будь-якого міста - ми працюємо для вашої зручності.
                </p>

                <h2 className="fs-5">Наш підхід</h2>
                <p>
                    Ми - інтернет-магазин, який цінує довіру кожного клієнта. Для нас важливо
                    не просто продати джинси, а допомогти вам підібрати <strong>чоловічі джинси Levi’s</strong>, 
                    які ідеально підійдуть за розміром, посадкою та стилем.
                </p>

                <p>
                    Якщо у вас виникли питання щодо моделей, розмірної сітки або посадки -
                    ми завжди готові допомогти.
                </p>

                <p>
                    <strong>
                        Дякуємо, що обираєте наш інтернет-магазин чоловічих джинсів Levi’s в Україні.
                        Якість та стиль Levi’s - з 2020 року.
                    </strong>
                </p>
            </div>
        </>
    );
}

export default About;